import { render, staticRenderFns } from "./HistoryLayout.vue?vue&type=template&id=23cf1168&scoped=true"
import script from "./HistoryLayout.vue?vue&type=script&lang=ts"
export * from "./HistoryLayout.vue?vue&type=script&lang=ts"
import style0 from "./HistoryLayout.vue?vue&type=style&index=0&id=23cf1168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cf1168",
  null
  
)

export default component.exports